import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 308px;
  justify-content: space-between;
  margin-top: -31px;

  & div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 146px;
  }
`;